module.exports = __webpack_public_path__ + "img/blog1-banner.04e88d2f.webp";